import { apiFetch } from '../../utils/apiClient';

const ID_KEY_BY_FOR = {
    1: 'idPost',
    2: 'idUser',
    3: 'idChat',
    4: 'idMessage',
    5: 'idComment',
};

export function useComplain() {
    return async ({ complainFor, contentId, reason, reasonText = null }) => {
        const idKey = ID_KEY_BY_FOR[complainFor];
        if (!idKey) throw new Error('Неверная категория жалобы');

        const res = await apiFetch('/api/complain', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                complainFor,
                reason,
                reasonText,
                [idKey]: contentId,
            }),
        });

        const data = await res.json().catch(() => ({}));

        if (!res.ok || data?.error) {
            throw new Error(data?.error || 'Ошибка при отправке жалобы');
        }

        return data;
    };
}
